// extracted by mini-css-extract-plugin
export default {"dragAndDropWrapper":"DragAndDrop_dragAndDropWrapper__Zl4Y6","dragAndDropOverlay":"DragAndDrop_dragAndDropOverlay__3R4wX"};